import * as types from "@common/components/steppers/store/steppers.actionType";
import steppersActions from "@common/components/steppers/store/steppers.actions";
import steppersSelectors from "@common/components/steppers/store/steppers.selectors";
import { takeEvery, put, select } from "redux-saga/effects";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.NEXT_STEP, nextStep);
  yield takeEvery(types.BACK_STEP, backStep);
  yield takeEvery(types.GO_TO_STEP, goToStep);
}

function* goToStep(action) {
  const { payload: step } = action;
  const { activeStep, steps } = yield select(steppersSelectors.steppers);

  if (steps.length > step || steps.length < step) {
    console.log("Step solicitado não existe na lista de Steps.");
  }

  if (activeStep === payload) {
    console.log("Step escolhido já está ativo.");
    return;
  }
  if (steps[step].disabled) {
    console.log("Step escolhido está desabilitado.");
    return;
  }

  yield put(steppersActions.setActiveStep(step));
}

function* nextStep() {
  const { activeStep, steps } = yield select(steppersSelectors.steppers);

  const step = steps.slice(activeStep + 1, steps.length).find(x => !x.disabled);

  const nextStep = activeStep === steps.length - 1 && !step ? activeStep : steps.indexOf(step);

  if (steps.length > nextStep) {
    yield put(steppersActions.setActiveStep(steps.length - 1));
  }

  if (steps.length < nextStep) {
    yield put(steppersActions.setActiveStep(0));
  }

  yield put(steppersActions.setActiveStep(nextStep));
}

function* backStep() {
  const { activeStep, steps } = yield select(steppersSelectors.steppers);

  if (activeStep === 0) return;

  var nextStep = activeStep - 1;

  yield put(steppersActions.setStep(nextStep));
}
